import { FormField, FormLabel } from "@impero-com/ui";

import { UserOrUserGroupTypeahead } from "components/userTypeahead";
import { UserOrUserGroupOverview } from "utils/user";

interface AssigneeFieldProps {
    id: string;
    label: string;
    value: UserOrUserGroupOverview | undefined;
    onSelect: (value: UserOrUserGroupOverview) => void;
}

export function AssigneeField({
    id,
    label,
    value,
    onSelect,
}: AssigneeFieldProps) {
    return (
        <FormField>
            <FormLabel>{label}</FormLabel>
            <UserOrUserGroupTypeahead
                id={id}
                value={value}
                onSelect={onSelect}
            />
        </FormField>
    );
}
